import React from "react";
import { Link } from "react-router-dom";
import { Loader2, AlertTriangle, X } from "lucide-react";
import { PLAN_LABEL, formatDate } from "./format";

export const CancelModal = ({ plan, expiresAt, cancelling, onConfirm, onClose }) => (
  <div
    data-testid="cancel-modal"
    className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4"
    onClick={() => !cancelling && onClose()}
  >
    <div className="bg-white rounded-2xl max-w-md w-full p-7 fade-up" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-start justify-between">
        <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-amber-100 text-amber-700">
          <AlertTriangle size={18} strokeWidth={1.8} />
        </div>
        <button
          onClick={() => !cancelling && onClose()}
          className="text-gray-400 hover:text-black"
          aria-label="Close"
        >
          <X size={18} strokeWidth={1.5} />
        </button>
      </div>
      <h3 className="font-display text-2xl tracking-tight font-medium mt-5">
        Cancel your {PLAN_LABEL[plan]} subscription?
      </h3>
      <p className="text-sm text-gray-600 leading-relaxed mt-3">
        You&apos;ll keep full access until <strong className="text-gray-900">{formatDate(expiresAt)}</strong> (the end of your current billing period), then drop to the Free plan. Your saved packets, profile, and history all stay. You can resume any time before that date with one click.
      </p>
      <p className="text-xs text-gray-500 leading-relaxed mt-3">
        See our <Link to="/refund-policy" className="underline hover:text-black">refund &amp; cancellation policy</Link> for prorated refund options.
      </p>
      <div className="mt-7 flex items-center justify-end gap-3">
        <button
          onClick={onClose}
          disabled={cancelling}
          className="text-sm font-medium px-5 py-2.5 rounded-lg border border-gray-300 hover:border-black"
        >
          Keep my plan
        </button>
        <button
          data-testid="cancel-confirm"
          onClick={onConfirm}
          disabled={cancelling}
          className="inline-flex items-center gap-2 text-sm font-medium px-5 py-2.5 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
        >
          {cancelling && <Loader2 size={14} className="animate-spin" />}
          Yes, cancel
        </button>
      </div>
    </div>
  </div>
);
